// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2yu3n","options":"AnswerScale_options__3ntKO","selected":"AnswerScale_selected__hDNn0"};